import React, { useContext, useRef, useState } from "react";
import '../TransactionTable/TransactionTable.css'
import { translate } from "utils/Translate";
import CustomCheckbox from "components/elements/CustomCheckbox";
import moment from "moment";
import { AppContext } from "contexts/AppContext";
import ButtonMedium4 from "components/elements/ButtonMedium4";
import { SendPointsModal } from "../SendPointsModal/SendPointsModal";
import ButtonMedium2 from "components/elements/ButtonMedium2";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Tooltip } from "@mui/material";
import Headline5 from "components/elements/Headline5";
import ContentNormal from "components/elements/ContentNormal";

const Sales = ({ setActivateComplete, sales, setSales, refreshData, setShowModal }) => {
  const {langCode, brandData, styleGuide} = useContext(AppContext)
  const [showSendPointsModal, setShowSendPointsModal] = useState(false);

  const activationPointsSectionLabels = brandData.features?.upgraderClubConfigurableLabels && brandData.features.upgraderClubConfigurableLabels[langCode]?.profilePageLabels?.activationPointsSectionLabels
     ? brandData.features.upgraderClubConfigurableLabels[langCode].profilePageLabels.activationPointsSectionLabels : null
  const sendPointsAndLoanLabels = brandData.features?.upgraderClubConfigurableLabels && brandData.features.upgraderClubConfigurableLabels[langCode]?.profilePageLabels?.sendPointsAndLoanLabels
     ? brandData.features.upgraderClubConfigurableLabels[langCode].profilePageLabels.sendPointsAndLoanLabels : null

  const getPointsBalance = () => {
    return sales.filter(s => s.status === 'WAITING' || s.status === 'COMPENSATION').reduce((sum,s) => sum + s.walletAmountPoints, 0)
  }

  const NoSalesLine = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "1rem",
        padding: 40,
      }}
    >
        <Headline5
          configuredLabel={activationPointsSectionLabels?.noPointsTitleText}
          translationKey="_PROFILE_PAGE_NO_SALES_CAPTION_"
          fallbackText="Ingen point endnu"
        />
        <ContentNormal
          style={{textAlign: 'center'}}
          configuredLabel={activationPointsSectionLabels?.noPointsContentText}
          translationKey="_PROFILE_PAGE_NO_SALES_TEXT_"
          fallbackText="Når der sker en transaktion, vil du se det her. "
        />
    </div>
  );

  if(!sales){
    return null
  }

  if(sales && !sales.length) {
    return <NoSalesLine />
  }

  return (
    <div className="transaction-table">
      <div style={{ display: "flex", flexDirection: "row", gap: 10, flexWrap: 'wrap' }}>
        <ButtonMedium4 showIcon={false}
          onClick={(e) => {
            e.stopPropagation()
            setShowModal(true)
          }}
          disabled={sales.filter(s => s.checked === true).length ? false : true}
          style={{ backgroundColor: sales.filter(s => s.checked === true).length ? styleGuide.color16 : styleGuide.color1, color: sales.filter(s => s.checked === true).length ? styleGuide.color1 : styleGuide.color18 }}
          translationKey="_PROFILE_ACTIVATE_SELECTED_BUTTON_"
          fallbackText="Aktivér valgte"
        />
        {!!brandData?.features?.sendPoints?.enableSendPointsWalletActivation &&
          <ButtonMedium2
            style={{ backgroundColor: styleGuide.color26 }}
            disabled={sales.filter(s => s.checked === true).length ? false : true}
            configuredLabel={sendPointsAndLoanLabels?.sendPointsButtonText}
            showIcon={false}
            translationKey="_PROFILE_PAGE_SEND_POINT_BUTTON_TEXT_"
            fallbackText="Send point"
            onClick={() => setShowSendPointsModal(true)}
          />
        }
      </div>
      <div className="table-head">
        <div className="th tcol-small">{'Vælg'}</div>
        <div className="th tcol-4">{activationPointsSectionLabels?.columnOneLabel ?? 'Note'}</div>
        <div className="th tcol-2">{activationPointsSectionLabels?.columnTwoLabel ?? 'Point'}</div>
        <div className="th tcol-2">{translate('_CREATION_DATE_', 'Dato for oprettelse')}</div>
        <div className="th tcol-2">{translate('_EXPIRATION_DATE_', 'Udløbsdato')}</div>
        {!brandData?.features?.disableActivateWalletFeature && <div className="th tcol-2">{activationPointsSectionLabels?.columnFiveLabel ?? 'Status'}</div>}
        <div className="th tcol-scroll"></div>
      </div>
      <div className="table-body" style={{overflowY: 'scroll'}}>
        {sales.map((sale, idx) => <Sale sale={sale} sales={sales} setSales={setSales} idx={idx} key={idx} getPointsBalance={getPointsBalance} refreshData={refreshData} />)}
      </div>

      {showSendPointsModal && 
        <SendPointsModal
          balance={getPointsBalance()}
          setShowSendPointsModal={setShowSendPointsModal}
          wallets={sales.filter(s => !!s.checked && s.walletAmountPoints > 0)}
          showSendPointsModal={showSendPointsModal}
          sendPointsAndLoanLabels={sendPointsAndLoanLabels}
          fetchWalletActivation={refreshData}
          setActivateComplete={setActivateComplete}
        />
      }
    </div>
  )
};


const Sale = ({sale, idx, sales, setSales}) => {
    const te = useRef(null)
    const { styleGuide, langCode, brandData } = useContext(AppContext);
    
    const activationPointsSectionLabels = brandData.features?.upgraderClubConfigurableLabels && brandData.features.upgraderClubConfigurableLabels[langCode]?.profilePageLabels?.activationPointsSectionLabels
     ? brandData.features.upgraderClubConfigurableLabels[langCode].profilePageLabels.activationPointsSectionLabels : null

    const expiryDate = moment(sale.timeInsert).add(6, 'M').endOf('month')
    const aboutToExpireDate = moment().subtract(5, 'months').startOf('month')

    return <div ref={te} className="tr" key={idx} style={{alignItems: "center", height: 52}}>
    {!brandData?.features?.disableActivateWalletFeature && <div className="td tcol-small">
        {
            sale.status === "WAITING" && sale.walletAmountPoints > 0 &&
            <CustomCheckbox
                style={{marginTop: 0, marginLeft: 16}}
                checked={sale.checked ? true : false}
                onChange={(e) => {
                    setSales(sales.map((sale,index) => {
                      if(index === idx){
                        sale.checked = e.target.checked
                      }
                      return sale
                    }))
                }}
            />
        }
      </div>}
      <div className="td tcol-4">{sale.walletNote}</div>
      <div className="td tcol-2">{sale.walletAmountPoints}</div>
      <div className="td tcol-2">{moment(sale.timeInsert).format('DD/MM/YYYY')}</div>
      <div className="td tcol-2" style={{color: sale.status === "WAITING" && moment(sale.timeInsert) < aboutToExpireDate ? styleGuide.color12 : styleGuide.color7}}>{expiryDate.format('DD/MM/YYYY')}</div>
      {!brandData?.features?.disableActivateWalletFeature && 
      <div className="td tcol-2" style={{ color: sale.status === "WAITING" ? styleGuide.color7 : sale.status === "ACTIVATED" ? styleGuide.color8 : sale.status === 'COMPENSATION' ? "#0077ff" : "#ff0000" }}>
        <span>{sale.status === "WAITING" ? activationPointsSectionLabels?.statusWaitingText || translate("_ACTIVATE_POINTS_","Aktivér point") : 
        sale.status === 'ACTIVATED' ? activationPointsSectionLabels?.statusActivatedText || translate("_ACTIVATED_","Aktiveret") : 
        sale.status === 'COMPENSATION' ? activationPointsSectionLabels?.statusCompensationText || translate("_COMPENSATION_","Udligning") :
        sale.status === 'PENDING' ? activationPointsSectionLabels?.statusPendingText || translate("_COMPENSATION_PENDING_","Afventer") :
        sale.status === 'TRANSFERRED' ? activationPointsSectionLabels?.statusCompensationText || translate("_TRANSFERRED_","Point overført") :
        activationPointsSectionLabels?.statusExpiredText || translate("_EXPIRED_","Udløbet")}</span>
        {!!sale.compensationNote && <Tooltip title={sale.compensationNote}><HelpOutlineIcon style={{marginLeft: 4, fontSize: 16}}/></Tooltip>}
      </div>}
    </div>
}

export default Sales;
